<script>
	import PageSection from '../../components/PageSection.svelte';
	import ClassActionEmailAddress from '../../components/ClassActionEmailAddress.svelte';
	import ClassActionPhoneNumber from '../../components/ClassActionPhoneNumber.svelte';

	import { projectSettings } from '../../config';
</script>

<PageSection>
	<div class="row justify-content-center">
		<div class="col-md-8 col-sm-12">
			<h1 class="text-center">{projectSettings.classActionName}</h1>
			<h2 class="text-center">REGISTRATION FORM</h2>
			<h2 class="text-center">
				Registration for this class action have now closed according to orders of the Court, which required
				registration by 4:00pm AEDT on 24 February 2025.
			</h2>
		</div>
	</div>

	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<p>
				If you wish to provide a late registration, please email us at
				<a title="Email emlclassaction@shine.com.au" href="mailto:emlclassaction@shine.com.au" target="_blank">
					emlclassaction@shine.com.au
				</a>
				with:
			</p>
			<p />

			<ol type="1">
				<li>the Group Members name (or names in the case of joint security holders);</li>
				<li>the address and/or email address of each Group Member;</li>
				<li>
					the full name of the registered owner and any relevant Holder Identification Number (<strong
						>HIN</strong
					>) or Security Reference Number (<strong>SRN</strong>) or equivalent reference number (if known) in
					respect of EML Securities held as at the close of trade on 18 December 2020 or acquired during the
					Relevant Period;
				</li>
				<li>
					the number of EML Securities held by each Group Member as at the close of trade on 18 December 2020,
					and if known, the exchange on which they were held;
				</li>
				<li>
					for each acquisition of EML Securities during the Relevant Period:
					<ol type="1">
						<li>the date of acquisition;</li>
						<li>the quantity acquired;</li>
						<li>the exchange on which they were acquired (if known); and</li>
						<li>the price of the shares acquired; and</li>
					</ol>
				</li>
				<li>
					for each sale of disposal of EML Securities during the Relevant Period (<strong
						>19 December 2020 and 25 July 2022</strong
					>):
					<ol type="1">
						<li>the date of disposal;</li>
						<li>the quantity disposed of;</li>
						<li>the exchange on which they were disposed of (if known); and</li>
						<li>the price of the shares sold.</li>
					</ol>
				</li>
				<li>explanation as to why your registration was late.</li>
			</ol>

			<p>We will consider that information and respond as to potential action that can be taken.</p>
		</div>
	</div>
	<div class="row justify-content-md-center register-btn">
		<div class="col-md-8 col-sm-12 text-center"></div>
		<div class="col-md-8 col-sm-12 text-center">
			<div class="recaptcha">
				<div id="g-recaptcha" data-sitekey={projectSettings.gSiteKey2}></div>
			</div>
		</div>
	</div>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<p>
				If you are in any doubt about whether you need to complete this form, or whether you have suffered
				damages, please contact Shine Lawyers on
				<ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
				<ClassActionEmailAddress></ClassActionEmailAddress>.
			</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2 {
		font-size: 1.1em;
		margin-bottom: 16px;
		font-weight: 700;
	}

	.register-btn {
		margin-bottom: 20px;
	}

	.recaptcha {
		padding-top: 20px;
		display: flex;
		justify-content: center;
	}
</style>
